import { render, staticRenderFns } from "./perAndVhcProcess.vue?vue&type=template&id=978af300&scoped=true&"
import script from "./perAndVhcProcess.vue?vue&type=script&lang=js&"
export * from "./perAndVhcProcess.vue?vue&type=script&lang=js&"
import style0 from "./perAndVhcProcess.vue?vue&type=style&index=0&id=978af300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978af300",
  null
  
)

export default component.exports